<template>
  <div class="l-page l-page--contact">
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w100p">
          <div class="c-title__text c-title__text--blue u-fs34">お問い合わせ</div>
        </div>
        <div class="c-text">
          PUSH ONEに関するお問い合わせ、詳しい資料請求は、こちらのお問い合わせフォームよりお願いいたします。<br />
          お電話でのお問い合わせは「052-307-0793」へご連絡下さい。<br />
          必要情報を入力の上、「送信する」ボタンを押してください。内容の確認後、担当よりご連絡させていただきます。<br />
        </div>
      </div>
      <contact-form :contact-types="contactTypes" />
    </main>
  </div>

</template>
<script>
export default {
  props: {
    contactTypes: Object,
  },
  mounted: function() {},
};
</script>
